<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import Cookies from "js-cookie";
import { mapMutations } from "vuex";
export default {
  name: "App",
  mounted() {
    this.setDocumentTitle(this.$route);
    this.setUserName(Cookies.get("user_name"));
    // 这里的逻辑是，获取地址栏的地址信息，获取到source=xxx的值，存起来
    const myLink = window.location.href;
    if (myLink.split("?").length > 1) {
      const paramsList = myLink.split("?")[1].split("&");
      if (paramsList.length >= 0) {
        const sourceArr = paramsList.filter(v => v.includes("source"));
        console.log("sourceArr", sourceArr);
        const source = sourceArr && sourceArr[0] && sourceArr[0].split("=")[1];
        console.log("source", source);
        source && this.$store.commit("setLinkSource", source);
      }
    }
  },
  created() {
    // 禁止跟随手机文字大小
    this.setting();
  },
  watch: {
    $route(newValue) {
      this.setDocumentTitle(newValue);
    }
  },
  methods: {
    ...mapMutations(["setUserName"]),
    // 禁止跟随手机文字大小
    setting() {
      // eslint-disable-next-line no-undef
      if (
        typeof WeixinJSBridge === "object" &&
        typeof WeixinJSBridge.invoke === "function"
      ) {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
      }
      function handleFontSize() {
        // 设置网页字体为默认大小
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke("setFontSizeCallback", {
          fontSize: 0
        });
        // 重写设置网页字体大小的事件
        // eslint-disable-next-line no-undef
        WeixinJSBridge.on("menu:setfont", function() {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.invoke("setFontSizeCallback", {
            fontSize: 0
          });
        });
      }
    },
    // 根据当前页面设置文档标题
    setDocumentTitle(route) {
      // 非示例报告页面，并且拥有name，则设置文档标题
      // 路由的name是一定存在的，根据name是否存在可以判断当前路由是否装载
      if (!route.path.includes("/demo") && route.name) {
        // 设置标题
        document.title =
          "微风企科技-企业资信评估|企业经营数据分析|企业财务数据分析|财税数据分析软件";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue